import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackSelectItemParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackSelectItem";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackSelectItem = (
    parameters: PartialSpecific<TrackSelectItemParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventListTrackerHook(ga.track.selectItem, parameters, options);
};

export default useTrackSelectItem;
